import React, { useState } from "react";
import uuid from "uuid";
import { Button, Icon, Dropdown } from "semantic-ui-react";

import DocumentPreview from "./DocumentPreview";

export const isImage = (filename) =>
  /\.(gif|jpg|jpeg|tiff|png|jfif)$/i.test(filename);

const baseUrl = `/dealer`;

export default function ItemUploader(props) {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputId = uuid();

  return (
    <div className="item-uploader">
      <div className="doc-meta">
        <Icon
          name={!props.image ? "question" : "circle check"}
          color={props.image ? "green" : null}
          size="big"
        />
        <h2>{props.title}</h2>
        {!props.image && props.upload && (
          <div className="doc-upload">
            <Button
              as="label"
              icon="upload"
              color="green"
              size="mini"
              content="Upload File"
              labelPosition="right"
              htmlFor={inputId}
            />
            <input
              hidden
              id={inputId}
              accept=".jpeg,.jpg,.gif,.png,.pdf"
              type="file"
              onChange={(e) =>
                props.onUpload({
                  image: e.target.files[0],
                  imageRef: props.imageRef,
                  imageType: props.imageType,
                  url: props.url,
                })
              }
            />
          </div>
        )}
      </div>
      {props.image && !loading && (
        <div className="item-actions">
          <Dropdown icon="ellipsis horizontal">
            <Dropdown.Menu>
              <Dropdown.Item
                text="Preview"
                icon="eye"
                onClick={() => setPreviewOpen(true)}
              />
              {props.addAnother && (
                <Dropdown.Item as="label">
                  <Icon name="plus" htmlFor={`${props.id}AnotherUpload`} />
                  <Button
                    content="Add Another"
                    basic
                    as="label"
                    htmlFor={`${props.id}AnotherUpload`}
                    className="add-another"
                    style={{
                      border: "none",
                      padding: "0",
                      outline: "none",
                      boxShadow: "none",
                    }}
                  />
                  <input
                    hidden
                    id={`${props.id}AnotherUpload`}
                    accept=".jpeg,.jpg,.gif,.png,.pdf"
                    type="file"
                    onChange={(e) => {
                      if (!e.target.files || !e.target.files.length) return;
                      setLoading(true);
                      props.onSupplementalUpload({
                        image: e.target.files[0],
                        imageRef: props.imageRef,
                        imageType: props.imageType,
                        url: props.url,
                      });
                      setTimeout(() => {
                        setLoading(false);
                      }, 100);
                    }}
                  />
                </Dropdown.Item>
              )}
              <Dropdown.Item
                text="Download"
                icon="download"
                as="a"
                download={props.image.filename}
                href={`${baseUrl}/api${props.url}${props.image.filename}`}
              />
              <Dropdown.Divider />
              <Dropdown.Item
                text="Delete"
                icon="trash"
                onClick={(e) => {
                  props.onDelete({
                    url: `${props.url}/${props.image.filename}/`,
                    imageRef: props.imageRef,
                    filename: props.image.filename,
                  });
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      {previewOpen && (
        <DocumentPreview
          src={`${baseUrl}/api${props.url}${props.image.filename}`}
          title={props.title}
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </div>
  );
}

ItemUploader.defaultProps = {
  addAnother: false,
  upload: true,
};
